import * as React from "react";
function SvgSearch(props, svgRef) {
  return <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path d="M20.0009 19.9999L16.3086 16.3076" style={{
      stroke: "var(--svg-color, var(--default-svg-color, #000))"
    }} strokeLinecap="square" /><circle cx={11} cy={11} r={6.5} style={{
      stroke: "var(--svg-color, var(--default-svg-color, #000))"
    }} strokeLinecap="round" /></svg>;
}
const ForwardRef = React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "src/assets/icons/search.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/search_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/search_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/search_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/search_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/search_4x.svg"
};
export { ForwardRef as ReactComponent };